import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {TabLink} from '../../model/component/tab-link';

@Component({
  selector: 'app-tabnav',
  templateUrl: './tabnav.component.html',
  styleUrls: ['./tabnav.component.css']
})
export class TabnavComponent implements OnInit {


  @Input()
  topics: Array<string>;
  @Input()
  goBackLink: boolean = false;

  @Output()
  onGoingBack: EventEmitter<boolean> = new EventEmitter<boolean>();

  tabLinks;

  constructor(public router: Router, private  location: Location, private activeRoute: ActivatedRoute) {
  }

  //Um eine Tabnavigation zu erstellen, kann der Komponente ein Array aus Topics gegeben werden
  //TODO: Evtl kann das hier weg, da zu kompliziert
  ngOnInit() {
    this.tabLinks = new Array();
    this.tabLinks.push(new TabLink('Zurück', false, 0));
  }

  public setLinkActive(link: TabLink) {
    for (let tabLink of this.tabLinks) {
      tabLink.active = false;
    }
    link.active = true;
  }

  public navigateBackToParent() {
    this.onGoingBack.emit(false);
    this.router.navigate([this.router.url.substring(0,this.router.url.lastIndexOf("/"))])
  }
}
